export const get_promo_url = () => {    
    return document.querySelector('meta[name="promotions-page-link"]').content;
}
